import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgModule, isDevMode } from '@angular/core';
import { TRANSLOCO_CONFIG, TRANSLOCO_LOADER, Translation, TranslocoLoader, TranslocoModule } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { InterceptorSkipHeader } from './app/common/interceptors/auth.interceptor';
import { assetPath } from './environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): Observable<Translation> {
    const headers = new HttpHeaders().set(InterceptorSkipHeader, '');

    return this.http.get<Translation>(`${ assetPath.length > 0 ? assetPath + '/' : ''  }assets/i18n/${lang}.json`, { headers });
  }
}

export const translocoConf = {
  availableLangs: ['de'],
  defaultLang: 'de',
  prodMode: !isDevMode(),
};

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConf,
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
  ],
})
export class TranslocoRootModule {}
